import { render } from "./EmployementStatistic.vue?vue&type=template&id=74b3773e&scoped=true"
import script from "./EmployementStatistic.vue?vue&type=script&lang=js"
export * from "./EmployementStatistic.vue?vue&type=script&lang=js"

import "./EmployementStatistic.vue?vue&type=style&index=0&id=74b3773e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b3773e"]])

export default __exports__